import React, {useContext} from "react";
import Seo, {SEOContext} from "gatsby-plugin-wpgraphql-seo";
import {
  graphql,
  useStaticQuery
} from "gatsby";
import {Helmet} from "react-helmet";

export const SeoProxy = (ref) => {
  let data = {...ref}
  const seoContext = useContext(SEOContext)
  const { site } = useStaticQuery(graphql`
    query DefaultSEOQuery {
      site {
        siteMetadata {
          title
          description
          author
          siteUrl
        }
      }
      sitePage {
        path
      }
    }
  `);

  if(data && data.post && data.post.page) {
    data.post = data.post.page
  }

  // add the og:locale from the global settings
  if(data && data.post && data.post.seo && data.post.seo.schema && !data.post.seo.schema.inLanguage)
    data.post.seo.schema.inLanguage = seoContext?.global?.schema?.inLanguage
  // override for featured image
  if(ref.imageData) {
    data.post.seo.opengraphImage.sourceUrl = ref.imageData.source
    if(!data.post.seo.opengraphImage.sourceUrl.match(/\/\/:/))
      data.post.seo.opengraphImage.sourceUrl = seoContext.global.schema.siteUrl + data.post.seo.opengraphImage.sourceUrl
  }
  // default if no featured image
  if(!data?.post?.seo?.opengraphImage) {
    data.post.seo.opengraphImage = {
      sourceUrl: seoContext?.global?.schema?.logo?.sourceUrl
    }
  }

  const postId = data && data.post && data.post.id ? data.post.id : null;

  return (
      <>
        {postId && (
            <Helmet>
              <meta name="postId" content={postId} />
            </Helmet>
        )}
        <Seo {...data} />
      </>
  )
}
